const transformTherapyDataSearch = (data = {}) => {
  if (Object.keys(data).length === 0) return {};
  const result = data.results?.[0];
  let transformedData = {};

  if (result?.component?.length > 0) {
    result.component.forEach((component) => {
      let value = null;
      let unit = null;

      if (Object.keys(component.value_quantity).length > 0) {
        value = component.value_quantity.value;
        unit = component.value_quantity.unit;
      }
      const { code, display } = component.code.coding[0];
      transformedData[code] = {
        id: result.id,
        patientId: result.patientId,
        value,
        unit,
        display,
        updatedAt: result.updatedAt,
      };
    });
  } else {
    let value =
      result?.valueQuantity?.value ||
      result?.valueString ||
      result?.valueBoolean ||
      result?.valueDateTime ||
      result?.valueInteger;
    let unit = result?.valueQuantity?.unit ?? null;
    const code = result?.code?.coding?.[0]?.code;
    transformedData = {
      [code]: {
        id: result?.id,
        patientId: result?.patientId,
        value,
        unit,
        display: result?.code?.coding?.[0]?.display,
        updatedAt: result?.updatedAt,
      },
    };
  }

  return transformedData;
};

export default transformTherapyDataSearch;
